import { render, staticRenderFns } from "./mTable.vue?vue&type=template&id=3c38b853&scoped=true&"
import script from "./mTable.vue?vue&type=script&lang=js&"
export * from "./mTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c38b853",
  null
  
)

export default component.exports